import { PlaceholdersId, TFComponent } from '@types';
import { CloudwareDisclaimerDocumentPlaceholder } from './cloudwareDisclaimerDoc';

export const cloudwareDocumentDisclaimer: TFComponent = {
	component: CloudwareDisclaimerDocumentPlaceholder,
	id: PlaceholdersId.cloudwareDocumentDisclaimer,
	name: 'cloudwareDocumentDisclaimer',
};
